import React, { useState } from 'react';
import { FileText, ChevronDown, ChevronUp } from 'lucide-react';

interface NarrativeReportProps {
  narrative: string;
}

export default function NarrativeReport({ narrative }: NarrativeReportProps) {
  const [expanded, setExpanded] = useState(true);

  const formatNarrative = (text: string) => {
    return text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/^### (.*$)/gm, '<h3>$1</h3>')
      .replace(/^## (.*$)/gm, '<h2>$1</h2>')
      .replace(/^# (.*$)/gm, '<h1>$1</h1>')
      .replace(/^- (.*$)/gm, '<li>$1</li>')
      .replace(/(<li>.*<\/li>\n?)+/g, '<ul>$&</ul>')
      .replace(/\n\n/g, '</p><p>')
      .replace(/\n/g, '<br/>');
  };

  return (
    <div className="card" style={{ padding: 28 }}>
      <button
        onClick={() => setExpanded(!expanded)}
        style={{
          width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          marginBottom: 16, background: 'none', border: 'none', cursor: 'pointer', padding: 0,
        }}
      >
        <h3 style={{ fontSize: 18, fontWeight: 700, color: '#fff', display: 'flex', alignItems: 'center', gap: 10 }}>
          <FileText size={20} color="#a5b4fc" />
          AI Clinical Narrative Report
        </h3>
        {expanded ? (
          <ChevronUp size={20} color="#64748b" />
        ) : (
          <ChevronDown size={20} color="#64748b" />
        )}
      </button>

      {expanded && (
        <div className="fade-in">
          <div style={{
            display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16,
            padding: '10px 14px', borderRadius: 10,
            background: 'rgba(99,102,241,0.06)', border: '1px solid rgba(99,102,241,0.1)',
          }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#6366f1', flexShrink: 0 }} />
            <p style={{ fontSize: 12, color: '#a5b4fc' }}>
              Generated by Azure OpenAI — Modeled after Harvard Medical School neurology protocols
            </p>
          </div>

          <div
            className="narrative-content"
            style={{ padding: '20px 24px', borderRadius: 14, background: 'rgba(5,5,16,0.5)', border: '1px solid rgba(99,102,241,0.06)' }}
            dangerouslySetInnerHTML={{ __html: formatNarrative(narrative) }}
          />
        </div>
      )}
    </div>
  );
}
